import $ from 'jquery';
import 'select2';

const $searchFormSearchPage = $( '.search-form--normal' );
const $searchModeSelect     = $( '.search_mode' );
const $searchFormNormal     = $( '.search-form__normal' );
const $searchFormExtended   = $( '.search-form__extended' );
const $switchButtons        = $( '.search-form-home__button' );
const $searchForm           = $( '.search-form-home' );
const $formInput            = $( '.search-form-home__input' );
const searchResultWrapper   = document.querySelector( '.search-results__wrapper--search-form' );

$searchModeSelect.select2( {
	minimumResultsForSearch: Infinity,
} );

$searchModeSelect.on( 'change', function () {
	if ( this.value === 'normal-search' ) {
		$searchFormNormal.addClass( 'active' );
		$searchFormExtended.removeClass( 'active' );
		$searchFormSearchPage.removeClass( 'search-form--extended' );
	} else if ( this.value === 'vehicle-search' ) {
		$searchFormNormal.removeClass( 'active' );
		$searchFormExtended.addClass( 'active' );
		$searchFormSearchPage.addClass( 'search-form--extended' );
	}
} );

$switchButtons.map( ( index, element ) => {
	$( element ).on( 'click', () => {
		$searchForm.toggleClass( 'search-form-home--normal' );
		$searchForm.toggleClass( 'search-form-home--extended' );

		if ( $( element ).hasClass( 'search-form-home__button--extended' ) && searchResultWrapper ) {
			searchResultWrapper.classList.add( 'active' )
		} else {
			searchResultWrapper.classList.remove( 'active' )
		}

		$formInput.map( ( index, element ) => {
			let $isDisabled = $( element ).prop( 'disabled' );
			$( element ).prop( 'disabled', !$isDisabled )
		} );
	} );
} );
